import { ReactNode } from 'react'
import * as React from 'react'

type Props = {
  children?: ReactNode
  color?: string
  backgroundColor?: string
  width?: string
  height?: string
  rotate?: string
}

const CrossCircleIcon: React.FunctionComponent<Props> = (props) => {
  const { width, height, color = '#000000' } = props
  return (
    <svg
      width={width ? width : '100%'}
      height={height ? height : '100%'}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      color={color}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  )
}

export default CrossCircleIcon
